import { useEffect, useState } from 'react';
import { useMicLevel } from 'hooks/useMicLevel';
import { stopStream } from 'utils/audio/stopStream';

/** A device that cannot be opened stays silent instead of failing. */
export function useAudioDevicePreview(deviceId: string | null) {
  const [stream, setStream] = useState<MediaStream | null>(null);

  useEffect(() => {
    if (!deviceId) {
      setStream(null);
      return;
    }
    let canceled = false;
    let opened: MediaStream | null = null;
    navigator.mediaDevices
      .getUserMedia({ audio: { deviceId: { exact: deviceId } } })
      .then((next) => {
        if (canceled) {
          stopStream(next);
          return;
        }
        opened = next;
        setStream(next);
      })
      .catch(() => {
        if (!canceled) setStream(null);
      });
    return () => {
      canceled = true;
      if (opened) stopStream(opened);
      setStream(null);
    };
  }, [deviceId]);

  return useMicLevel(stream, stream !== null);
}
